import infoTemplate from './info.ejs';
import styles from './styles.less';

export default ({ content = '', ...props }: any) => infoTemplate({ ...props, content, styles });
